module.exports = __webpack_public_path__ + "static/img/wujiaoxing.e5d759be.png";